import { render, staticRenderFns } from "./ns-paginate.vue?vue&type=template&id=d1aa9584&"
import script from "./ns-paginate.vue?vue&type=script&lang=js&"
export * from "./ns-paginate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports